/**
 * Legacy Values - NOT from Figma DLS
 *
 * These values exist in the theme but have NOT been defined in Figma tokens.
 * They are preserved here for tracking and future DLS alignment.
 *
 * When Figma provides updated tokens for these, move them to the appropriate
 * token file (colors.ts, typography.ts, etc.) and remove from here.
 */

export const legacyCardBackground = {
  main: 'rgba(242, 242, 242, 1)',
} as const;

export const legacyWhite = {
  main: 'rgba(255, 255, 255, 1)',
} as const;

export const legacyDivider = 'rgba(211, 212, 215, 1)';

export const legacyTextDisabled = 'rgba(211, 212, 215, 1)';

export const legacyTertiary = {
  lightBlue: '#51B2D9',
  blue: '#3065A3',
  darkBlue: '#153A59',
  green: '#4AA596',
  teal: '#50AFBD',
  yellow: '#F5C844',
  orange: '#DB7934',
  lightGray: '#ACC0C7',
  black: '#222934',
} as const;

export const legacyAction = {
  active: 'rgba(0, 0, 0, 0.56)',
  selected: 'rgba(33, 150, 243, 0.08)',
  hover: 'rgba(244, 244, 244, 1)',
  focus: 'rgba(0, 0, 0, 0.12)',
  disabled: 'rgba(0, 0, 0, 0.38)',
} as const;

export const legacyError = {
  main: 'rgba(241, 76, 46, 1)',
  dark: 'rgba(168, 53, 32, 1)',
  light: 'rgba(243, 111, 87, 1)',
} as const;

export const legacyWarning = {
  main: 'rgba(246, 196, 74, 1)',
  dark: 'rgba(172, 137, 51, 1)',
  light: 'rgba(247, 207, 110, 1)',
} as const;

export const legacyInfo = {
  main: 'rgba(85, 138, 232, 1)',
  dark: 'rgba(59, 96, 162, 1)',
  light: 'rgba(119, 161, 236, 1)',
} as const;

export const legacySuccess = {
  main: 'rgba(0, 128, 0, 1)',
  dark: 'rgba(0, 89, 0, 1)',
  light: 'rgba(51, 153, 51, 1)',
} as const;

export const legacyBackground = {
  default: 'rgba(255, 255, 255, 1)',
} as const;

export const legacyTypography = {
  htmlFontSize: 10,
  letterSpacing: {
    body1: '0.15px',
    body2: '0.17px',
    subtitle1: '0.15px',
    subtitle2: '0.1px',
    overline: '1px',
    caption: '0.15px',
    h1: '-1.5px',
    h2: '-0.5px',
    h4: '0.25px',
    h6: '0.15px',
  },
} as const;

export type LegacyTypography = typeof legacyTypography;
